import { IsNotEmpty, IsNumber, IsPositive } from 'class-validator';

export class UserBalanceDto {
  @IsNotEmpty()
  email: string = '';

  @IsNotEmpty()
  @IsPositive()
  @IsNumber()
  amount: number = 0;

  lastUpdate?: number;

  error?: string;

  constructor(email: string, balance: number, lastUpdate: number, error: string) {
    this.email = email;
    this.amount = balance;
    this.lastUpdate = lastUpdate;
    this.error = error;
  }
}
